import { gql } from "@apollo/client";

export const batchUpdateAbExposure = gql`
    mutation batchUpdateAbExposure($studyTreatmentInfo: [StudyTreatmentInfo!]) {
        batchUpdateAbExposure(input: { studyTreatmentInfo: $studyTreatmentInfo })
    }
`;
